import { useEffect, useState } from "react";
import { studiesService } from "../service";

export const useStudies = () => {
  const [studies, setStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showNewStudy, setShowNewStudy] = useState(false);

  const handleAddClick = () => setShowNewStudy(true);
  const handleBack = () => setShowNewStudy(false);

  const fetchStudies = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("access_token");
      if (!token) {
        setError("Vous devez être connecté pour voir vos études.");
        return;
      }

      const res = await studiesService.getOwn(); 
      const data = res.data || res; 
      setStudies(data);
    } catch (err) {
      console.error("Erreur lors du chargement des études :", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!showNewStudy) fetchStudies();
  }, [showNewStudy]);

  return {
    studies,
    loading,
    error,
    showNewStudy,
    handleAddClick,
    handleBack,
    refreshStudies: fetchStudies,
  };
};
